let homeBgRaf = null;
let homeBgScrollHandler = null;
let homeBgResizeHandler = null;

function clamp01(value) {
  return Math.max(0, Math.min(1, value));
}

export function initHomeBackground() {
  if (homeBgRaf) {
    window.cancelAnimationFrame(homeBgRaf);
    homeBgRaf = null;
  }
  if (homeBgScrollHandler) {
    window.removeEventListener("scroll", homeBgScrollHandler);
    homeBgScrollHandler = null;
  }
  if (homeBgResizeHandler) {
    window.removeEventListener("resize", homeBgResizeHandler);
    homeBgResizeHandler = null;
  }

  const home = document.querySelector(".c-home");
  if (!(home instanceof HTMLElement)) return;

  const sections = home.querySelector(".c-home-sections");
  const sectionItems = home.querySelectorAll(".c-home-section");
  const lastSection = sectionItems.length
    ? sectionItems[sectionItems.length - 1]
    : null;

  if (!(sections instanceof HTMLElement) || !(lastSection instanceof HTMLElement)) {
    home.style.setProperty("--home-blue-opacity", "0");
    home.style.setProperty("--home-base-opacity", "1");
    return;
  }

  let sectionsStart = 0;
  let sectionsEnd = 0;
  let ticking = false;
  let lastBlueOpacity = -1;
  let lastBaseOpacity = -1;

  const computeRanges = () => {
    const scrollY = window.scrollY || window.pageYOffset || 0;
    sectionsStart = sections.getBoundingClientRect().top + scrollY;
    sectionsEnd =
      lastSection.getBoundingClientRect().top +
      scrollY +
      lastSection.offsetHeight;
  };

  const applyScrollState = () => {
    const y = window.scrollY || window.pageYOffset || 0;
    const safeStart = Math.max(1, sectionsStart);

    let blueOpacity = 0;
    if (y < sectionsStart) {
      blueOpacity = clamp01(y / safeStart);
    } else if (y <= sectionsEnd) {
      const p = clamp01((y - sectionsStart) / Math.max(1, sectionsEnd - sectionsStart));
      blueOpacity = 1 - p;
    }

    let baseOpacity = 1;
    if (y > sectionsStart) {
      const p = clamp01((y - sectionsStart) / Math.max(1, sectionsEnd - sectionsStart));
      baseOpacity = 1 - p;
    }

    if (Math.abs(blueOpacity - lastBlueOpacity) > 0.004) {
      home.style.setProperty("--home-blue-opacity", blueOpacity.toFixed(3));
      lastBlueOpacity = blueOpacity;
    }
    if (Math.abs(baseOpacity - lastBaseOpacity) > 0.004) {
      home.style.setProperty("--home-base-opacity", baseOpacity.toFixed(3));
      lastBaseOpacity = baseOpacity;
    }
  };

  const requestUpdate = () => {
    if (ticking) return;
    ticking = true;
    homeBgRaf = window.requestAnimationFrame(() => {
      ticking = false;
      applyScrollState();
    });
  };

  computeRanges();
  applyScrollState();

  homeBgScrollHandler = requestUpdate;
  homeBgResizeHandler = () => {
    computeRanges();
    requestUpdate();
  };

  window.addEventListener("scroll", homeBgScrollHandler, { passive: true });
  window.addEventListener("resize", homeBgResizeHandler);
}
